/*
* blocktimes.js
*
* Description: Holds 'Stores' Logic for Module:'Blocktimes'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Flights"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> blocktimes -------------------------------------
    airports_airports: [],
    airports_airports_Filtered: [],
    // >>> blocktimes - search/filter ---------------------
    airports_filterTerm: null

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Airports' -
    ***************************************************************************/
    /***************************************************************************
    * get_Airports()
    *
    * Desc:
    * Note:
    *
    */
    get_Airports: state => {

        return state.airports_airports;

    }, // eo function get_Airports()


    /***************************************************************************
    * get_Airports_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Airports_Filtered: state => {

        return state.airports_airports_Filtered;

    } // eo function get_Airports_Filtered()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Airports', Call: Get Airports
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getAirports()
    *
    * Desc: Save 'Airports' (unfiltered).
    * Note:
    *
    */
    mut_call_getAirports: (state, payload) => {

        const sortedAirports = [...payload.payload];

        sortedAirports.sort((a, b) => a.iataCode < b.iataCode ? -1 : 1);

        // add aptCode to equal the airport object from /getlegsinfo Response
        // to work smoothly
        sortedAirports.forEach((airport) => {
            airport.aptCode = airport.iataCode;
        });

        state.airports_airports = sortedAirports; // save

        // >>> Rebuild ------------------------------------
        payload.context.commit('mut_filter_Airports'); // rebuild

    }, // eo function mut_call_getAirports()


    /***************************************************************************
    * Mutations: 'Airports', Call: Create/Update Airports
    ***************************************************************************/
    /***************************************************************************
    * mut_call_updateCreateAirports()
    *
    * Desc: Save 'Airports' (unfiltered).
    * Note: Is ID of payload currently used -> update case
    * Note: Otherwise -> create case
    *
    */
    mut_call_updateCreateAirports: (state, payload) => {

        const isUpdateCase = state.airports_airports.some(airport => airport.id === payload.payload.id),
            airports_airportsCopy = [];


        // >>> Update Case --------------------------------
        if (isUpdateCase === true) {
            state.airports_airports.forEach((item) => {
                if (item.id === payload.payload.id) {
                    item = payload.payload; // 'overwrite'

                    item.wasEdited = true;
                }
                airports_airportsCopy.push(item);
            });

            state.airports_airports = airports_airportsCopy;
        }

        // >>> Create Case --------------------------------
        if (isUpdateCase === false) {
            state.airports_airports.push(payload.payload);
        }


        // >>> Rebuild ------------------------------------
        payload.context.commit('mut_filter_Airports');

    }, // eo function mut_call_updateCreateAirports()


    /***************************************************************************
    * Mutations: 'Airports', Call: Delete Airport
    ***************************************************************************/
    /***************************************************************************
    * mut_call_deleteAirport())
    *
    * Desc: Delete Index from 'airports_airports_Filtered'.
    * Note: Delete in filtered AND in original resources list (airports_airports).
    *
    */
    // mut_call_deleteAirport: (state, payload) => {

    //     let index_airports_Filtered = state.airports_airports_Filtered.findIndex(i => i.id === payload.id),
    //         index_airports_Airports = state.airports_airports.findIndex(i => i.id === payload.id);


    //     if (index_blocktimes_Filtered > -1) {
    //         state.airports_airports_Filtered.splice(index_airports_Filtered, 1);
    //     }

    //     if (index_airports_Airports > -1) {
    //         state.airports_airports.splice(index_airports_Airports, 1);
    //     }

    // }, // eof mut_call_deleteAirport()




    /***************************************************************************
    * Actions: 'Airports' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filterAirports_filterTerm()
    *
    * Desc: Simply set/save airports_filterTerm
    * Note:
    *
    */
    mut_set_filterAirports_filterTerm: (state, payload) => {

        state.airports_filterTerm = payload; // save

    }, // eo function mut_set_filterAirports_filterTerm()


    /***************************************************************************
    * mut_filter_Airports()
    *
    * Desc: (Re)build 'new' 'airports_airports_Filtered'.
    * Note:
    *
    */
    mut_filter_Airports: (state) => {

        // >>> 'filterFilterTerm' -------------------------
        const filterFilterTerm = (resource) => {
            let applyFilter = false;

            if (state.airports_filterTerm && state.airports_filterTerm.length > 0) {
                if (resource.airportName.match(new RegExp(state.airports_filterTerm, 'i'))) {
                    applyFilter = true;
                }
                if (resource.iataCode.match(new RegExp(state.airports_filterTerm, 'i'))) {
                    applyFilter = true;
                }
                if (resource.icaoCode.match(new RegExp(state.airports_filterTerm, 'i'))) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.airports_filterTerm === null || state.airports_filterTerm.length === 0) {
                applyFilter = true;
            }

            return applyFilter;
        };


        // >>> Rebuild ------------------------------------
        state.airports_airports_Filtered = state.airports_airports.filter(resource => filterFilterTerm(resource));

    } // eo function mut_filter_Airports()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Airports', Call: Get Airports
    ***************************************************************************/
    /***************************************************************************
    * Call::'/acm/airport'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_getAirports: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('/acm/airport')
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getAirports', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });


    }, // eo function actn_call_getAirports()


    /***************************************************************************
    * Actions: 'Airports', Call: Create/Update Airports
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/acm/airport'
    *
    * Desc: Create/ Update airport.
    * Note:
    *
    */
    actn_call_updateCreateAirports: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/airport', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_updateCreateAirports', { payload: response.data, context: context });
                        eventBus.$emit('airportwasupdatedcreated'); // emit ..
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_updateCreateAirports()

    /***************************************************************************
    * Actions: 'Airports' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * actn_set_filterBlocktimes_filterTerm()
    *
    * Desc: Set 'filter Terms' and 'refilter'.
    * Note:
    *
    */
    actn_set_filterAirports_filterTerm: (context, payload) => {

        context.commit('mut_set_filterAirports_filterTerm', payload); // save term
        context.commit('mut_filter_Airports'); // rebuild

    } // eo function actn_set_filterBlocktimes_filterTerm()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
